module.exports = __webpack_public_path__ + "img/banner2.bb7dcf8e.png";